import { Col, Flex, message, Row } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import {
  deleteExternalWebhookById,
  fetchExternalWebhookById,
} from "@/lib/api/resources/externalWebhooks";
import { ExternalWebhookDetailCard } from "./components/ExternalWebhookDetailCard";

export const ExternalWebhookDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  if (!id) return null;

  const { data, isLoading } = useQuery({
    queryKey: ["ExternalWebhook", id],
    queryFn: () => fetchExternalWebhookById(id),
  });

  const deleteExternalWebhookMutation = useMutation({
    mutationFn: () => deleteExternalWebhookById(id),
    onSuccess: () => {
      navigate(`/external-webhooks`);
      message.success("Externe webhook succesvol verwijderd");
    },
    onError: () =>
      message.error(
        "Er is een fout opgetreden bij het verwijderen van de externe webhook",
      ),
  });

  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={12}>
          <Flex vertical gap={16}>
            <ExternalWebhookDetailCard
              deleteMutation={deleteExternalWebhookMutation}
              externalWebhook={data}
              isLoading={isLoading}
            />
          </Flex>
        </Col>
      </Row>
    </div>
  );
};
